<template>
<div>
    <div class="appointment-record">
        <div class="appointment-title">
            <span>预约报表</span>
            <div class="search-box">
                <!--
                    <el-select
                        style="margin-right: 10px;"
                        v-model="value"
                        filterable
                        clearable
                        placeholder="按城市查找"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    -->
                <!-- 
                    <el-cascader
                        v-if="departmentTree.length > 0"
                        class="mr10 w10rem"
                        placeholder="按部门查找"
                        :props="{ checkStrictly: true }"
                        :options="departmentTree"
                        filterable
                        clearable
                        :show-all-levels="false"
                    ></el-cascader> -->
                <el-date-picker class="daterange" v-model="daterange" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="changePicker"></el-date-picker>
            </div>
        </div>
        <el-table :data="intoReportData" show-summary style="width: 100%">
            <el-table-column prop="date" fixed label="时间" align="center"></el-table-column>
            <el-table-column prop="city" fixed label="地区" align="center"></el-table-column>
            <el-table-column prop="totals" label="预约到店" align="center">
                <template slot-scope="scope">
                    <el-link style="color: red;" @click="openForward(scope.row)">{{scope.row.totals}}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="uninto" label="预约未到店" align="center"></el-table-column>
            <el-table-column prop="into" label="实际到店" align="center"></el-table-column>
            <el-table-column prop="order" label="订单" align="center"></el-table-column>
        </el-table>
    </div>

    <el-dialog :title="detailDialog.title" :visible.sync="detailDialog.visible" width="75%" id="out-table">
        <el-table :data="intoTableData" height="350" style="width: 100%" v-loading="loading">
            <el-table-column prop="staff" label="预约人" align="center"></el-table-column>
            <el-table-column prop="department" label="部门" align="center"></el-table-column>
            <el-table-column prop="realname" label="客户姓名" align="center"></el-table-column>
            <el-table-column prop="source" label="渠道" align="center"></el-table-column>
            <el-table-column prop="subscribe" label="预约时间" align="center"></el-table-column>
            <el-table-column prop="store" label="预约门店" align="center"></el-table-column>
            <el-table-column prop="status" label="预约状态" align="center"></el-table-column>
            <el-table-column prop="mobile" label="联系方式" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center" width="300" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="exportExcel">导 出</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import fileSaver from 'file-saver';
import xlsx from 'xlsx';

export default {
    data() {
        return {
            loading: false,

            options: [{
                    value: '选项1',
                    label: '黄金糕'
                },
                {
                    value: '选项2',
                    label: '双皮奶'
                }
            ],
            value: '',
            departmentTree: [],
            daterange: [],
            detailDialog: {
                title: '预约详情',
                visible: false
            },
            intoReportData: [],
            intoTableData: [],
            pickerOptions: {
                shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }
                ]
            }
        };
    },
    created(options) {
        this.getIntoReportData();

        // 获取部门树
        this.getDepartmentTree();
    },
    mounted() {
        let that = this;
        let table = document.querySelector('.el-table__footer-wrapper>table');
        this.$nextTick(() => {
            table.rows[0].cells[2].style.cursor = 'pointer'
            table.rows[0].cells[2].style.textAlign = 'center'
            table.rows[0].cells[2].setAttribute("class", 'totalRed');
            table.rows[0].cells[2].onclick = function () {
                let url = '/api/statistics.into/detail';
                let range = that.daterange;
                let query = {
                    range: range
                };
                that.$post(url, query).then(function (response) {
                    let result = response.data;
                    that.intoTableData = result.list;
                    that.detailDialog.visible = true;
                });
            };
        });
    },
    methods: {
        getIntoReportData() {
            let that = this;
            that.loading = true
            let url = '/api/statistics.into/report';
            let range = this.daterange;
            that.$post(url, {
                range: range
            }).then(function (response) {
                let result = response.data;
                that.intoReportData = result.list;
                that.loading = false
            });
        },
        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 打开详情
        openForward(row) {
            let that = this;
            that.loading = true
            let url = '/api/statistics.into/detail';
            let query = {
                date: row.date,
                city_id: row.city_id
            };
            that.$post(url, query).then(function (response) {
                let result = response.data;
                that.intoTableData = result.list;
                that.detailDialog.visible = true;
                that.loading = false
            });
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#out-table'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    'sheetjs.xlsx'
                );
            } catch (e) {
            }
            return wbout;
        },
        changePicker() {
            this.getIntoReportData();
        }
    }
};
</script>

<style>
.daterange {
    float: right;
    width: 15rem !important;

}

.black {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.7;
    z-index: 11;
}

.appointment-title {
    font-size: 14px;
    border-left: 5px solid #409eff;
    padding-left: 20px;
    margin-bottom: 20px;
}

.appointment-record {
    padding: 20px;
}

.appointment-detail {
    width: 74%;
    height: auto;
    position: fixed;
    left: 13%;
    top: 20%;
    z-index: 12;
    padding: 20px;
    background: #fff;
    border-radius: 5px;
}

.appointment-detail-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
}

.appointment-detail-title span {
    font-size: 14px;
    border-left: 5px solid #409eff;
    padding-left: 20px;
}

.totalRed {
    text-align: center;
}

.totalRed .cell {
    color: red !important;
}
</style>
